import React from "react"
import { connect } from "react-redux"
import { dummyClick } from "../../utilities"
import Title from "../Card/Title"
import Subtitle from "../Card/Subtitle"
import Text from "../Card/Text"
import Icon from "../Card/Icon"
import { PremiumPrice } from "../RecommendedEpisodes/PremiumEpisode"
import { PremiumLabel } from "../RecommendedStories/PremiumStory"

const WIDTH = 144
const WIDTH_PX = `${WIDTH}px`

const getL = (language) => {
  return {
    en: "en-US",
    de: "de-DE"
  }[language]
}

const NovelPremium = ({ premium }) => {
  if (premium.premium && premium.price > 0) {
    if (premium.paid) {
      return (
        <PremiumLabel className="a-green">{I18n.t("common.paid")}</PremiumLabel>
      )
    } else {
      return <PremiumPrice price={premium.price} />
    }
  } else {
    return (
      <PremiumLabel className="a-green">{I18n.t("common.free")}</PremiumLabel>
    )
  }
}

const NovelCard = ({
  title,
  published_on,
  likesCount,
  commentCount,
  borderStyle,
  premium,
  onClick,
  languageSelected
}) => {
  const date = new Date(published_on)
  const month = date.toLocaleString(getL(languageSelected), { month: "short" })
  return (
    <div
      className={`a-card shadow-4 rounded-3 ${borderStyle}`}
      onClick={onClick}
      style={{ width: WIDTH_PX }}
    >
      <div className="p6 sm-p1">
        <Title noPadding>{title}</Title>
        <Subtitle>
          {month} {date.getDate()}, {date.getFullYear()}
        </Subtitle>
        <Text className="t-pt2">
          <Icon url="/images/pop-like-icon.svg" className="t-pr2">
            {" "}
            {likesCount}{" "}
          </Icon>
          <Icon url="/images/pop-comment-icon.svg"> {commentCount} </Icon>
        </Text>
        <div className="t-mt1">
          <NovelPremium premium={premium} />
        </div>
      </div>
    </div>
  )
}

NovelCard.defaultProps = {
  onClick: dummyClick,
  borderStyle: "",
  style: {}
}

// withSelection HOC

const withSelection = (Card) => ({ selected, upNext, ...rest }) => {
  const borderStyle = selected ? { borderStyle: "a-card-selected" } : {}
  return (
    <div className="selected">
      {selected && <p className="t-mt0 ttu f--3">{upNext}</p>}
      <Card {...Object.assign(rest, borderStyle)} />
    </div>
  )
}

const mapState = (state, ownProps) => ({
  languageSelected: state.signin.languageSelected
})

const NovelCardWithSelection = connect(mapState)(withSelection(NovelCard))

NovelCardWithSelection.defaultProps = {
  upNext: "EN Up next"
}

export default connect(mapState)(NovelCard)
export { NovelCardWithSelection }
